import defaultTheme from './defaultTheme';
const virginTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#f20024', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#FFFFFF', background: '#f20024' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#3b3c43' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#f20024', border: '#f20024', background: '#f20024' }), field: {
        focus: '#f20024',
        label: '#f20024',
        icon: '#f20024',
    } });
export default virginTheme;
